import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { KeyRound, Loader2 } from "lucide-react";
import { PasswordInput } from "../components/PasswordInput";

import { _t } from "@/lib/i18n";
export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  useEffect(() => { if (!token) toast.error(_t("Link non valido")); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error(_t("Le password non coincidono"));
    if (pw.length < 8) return toast.error(_t("Minimo 8 caratteri"));
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (err) {
      const msg = err?.response?.data?.detail || _t("Errore");
      if (String(msg).toLowerCase().includes("scad")) toast.error(_t("Link scaduto. Richiedi un nuovo reset."));
      else if (String(msg).toLowerCase().includes("utilizzato")) toast.error(_t("Link già utilizzato."));
      else toast.error(msg);
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0b0d] px-4">
      <div className="tc-card p-8 md:p-10 w-full max-w-md">
        <div className="mb-6 flex items-center gap-3">
          <KeyRound className="w-6 h-6 text-[#FF5722]" />
          <h1 className="font-display text-2xl text-white">{_t("Imposta una nuova password")}</h1>
        </div>
        {done ? (
          <div data-testid="reset-done" className="text-white/80">
            <p>{_t("Password aggiornata. Ti stiamo portando al login…")}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <PasswordInput testId="reset-pw-input" required minLength={8} autoComplete="new-password"
                   value={pw} onChange={(e) => setPw(e.target.value)}
                   placeholder={_t("Nuova password (min. 8 caratteri)")} />
            <PasswordInput testId="reset-pw-input2" required minLength={8} autoComplete="new-password"
                   value={pw2} onChange={(e) => setPw2(e.target.value)}
                   placeholder={_t("Ripeti nuova password")} />
            <button data-testid="reset-submit" type="submit" disabled={busy || !token} className="btn-primary w-full">
              {busy ? <><Loader2 className="w-4 h-4 animate-spin" />{" "}{_t("Aggiorno…")}</> : _t("Aggiorna password")}
            </button>
            <Link to="/login" className="block text-sm text-white/50 text-center hover:text-white">{_t("Annulla")}</Link>
          </form>
        )}
      </div>
    </div>
  );
}
